import { activateAdminEvent, cancelAdminEvent, createAdminEvent, type AdminAuditLogRecord } from "./api";
import type { GmEventInput } from "./gmEvents";
import type { GlobalEvent } from "../domain/types";


export interface GmEventMutation {
  event: GlobalEvent;
  auditLog?: AdminAuditLogRecord;
  reloadAdminData: boolean;
  statusLine: string;
}

export async function createSessionGmEvent(eventInput: GmEventInput): Promise<GmEventMutation> {
  const now = new Date();
  const endsAt = gmEventEndsAt(now, eventInput.durationHours);
  const result = await createAdminEvent({
    title: eventInput.title.trim() || "GM 未命名事件",
    severity: eventInput.severity,
    scopeType: eventInput.scopeType,
    scopeValue: eventInput.scopeValue,
    reason: eventInput.reason.trim() || "GM 手工下发",
    effects: eventInput.effects,
    activateNow: eventInput.activateNow,
    endsAt
  });
  return {
    event: result.event,
    reloadAdminData: true,
    statusLine: `GM 事件已${gmEventMutationVerb(result.event.status)}：${result.event.title}`
  };
}

export async function activateSessionGmEvent(eventId: string): Promise<GmEventMutation> {
  const result = await activateAdminEvent(eventId);
  return {
    event: result.event,
    reloadAdminData: true,
    statusLine: `GM 事件已激活：${result.event.title}`
  };
}

export async function cancelSessionGmEvent(eventId: string): Promise<GmEventMutation> {
  const result = await cancelAdminEvent(eventId);
  return {
    event: result.event,
    reloadAdminData: true,
    statusLine: `GM 事件已取消：${result.event.title}`
  };
}

export function mergeGmEvent(events: GlobalEvent[], event: GlobalEvent): GlobalEvent[] {
  return [event, ...events.filter((item) => item.id !== event.id)];
}

export function mergeActiveGmEvent(events: GlobalEvent[], event: GlobalEvent): GlobalEvent[] {
  const withoutCurrent = events.filter((item) => item.id !== event.id);
  if (event.status === "active") {
    return [event, ...withoutCurrent];
  }
  return withoutCurrent;
}

function gmEventEndsAt(now: Date, durationHours: number): string | undefined {
  if (durationHours <= 0) {
    return undefined;
  }
  const durationMs = durationHours * 60 * 60 * 1000;
  return new Date(now.getTime() + durationMs).toISOString();
}

function gmEventMutationVerb(status: GlobalEvent["status"]): string {
  if (status === "active") {
    return "激活";
  }
  return "保存";
}
